import { NextJsRemoteConfigProvider } from '@spotify-internal/remote-config-integration-nextjs';

import {
  Configuration,
  defineBool,
} from '@spotify-internal/remote-config-properties';
import React, { PropsWithChildren } from 'react';
import { useUser } from '../user/useUser';
import { useTransport } from '../useTransport';

export const releaseNotes = defineBool({
  name: 's4mp-release-notes',
  description: 'show s4mp release notes in side bar',
  default: false,
});

export const RemoteConfig = ({ children }: PropsWithChildren<{}>) => {
  const { userInfo } = useUser();
  let resolveContext: null | { username: string | null; auth: boolean } = null;

  if (userInfo?.profile) {
    resolveContext = { username: userInfo.profile.username, auth: true };
  }
  const transport = useTransport();

  return (
    <NextJsRemoteConfigProvider
      options={{
        transport,
        clientId: 's4mp-micro-frontends',
        properties: [releaseNotes],
        timeout: 20000,
        initialConfiguration: Configuration.empty(),
      }}
      context={resolveContext}
    >
      {children}
    </NextJsRemoteConfigProvider>
  );
};
